import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import { INDIA_COUNTRY } from "../../constants/conts";
const { Option } = Select;

/**
 * Props:
 * - countryId: string (required)
 * - value: string (optional, for controlled mode in Form.Item)
 * - onChange: function (stateId) => void
 * - disabled: boolean
 */

const StateSelect = ({ countryId = INDIA_COUNTRY, value, onChange, disabled = false }) => {

  const { request } = useRequest();
  const [stateList, setStateList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchStates = async () => {

    if (!countryId) {
      setStateList([]);
      return;
    }
  
    setLoading(true);
    request({
      url: `${apiPath.commonState}?country_id=${countryId}`,
      method: "GET",
      onSuccess: (res) => {
        const states = res?.data?.data || [];
        setStateList(states);
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err?.response?.data?.message || "Failed to load states", Severty.ERROR);
      },
    });
  }

  useEffect(() => {
    fetchStates();
  }, [countryId]);

  return (
    <Spin spinning={loading} tip="Loading states..." size="small">
      <Select
        showSearch
        allowClear
        placeholder={countryId ? "Select state" : "Select country first"}
        optionFilterProp="children"
        value={value}
        onChange={(val) => onChange?.(val)}
        disabled={!countryId || disabled}
        loading={loading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={{ height: 40 }}
      >
        {stateList?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default StateSelect;
